<template>
    <div class="services-container">
        <v-container class="services">
            <h2 v-html="blockTitle"></h2>
            <v-layout wrap row class="services-list">
                <v-flex class="service-item" xs12 sm6 md3 v-for="(service, key) in services" :key="key">
                    <a :href="service.link" v-html="service.name"/>
                </v-flex>
            </v-layout>
        </v-container>
    </div>
</template>
<script>
export default {
    props: ['title'],
    data: () => ({
        blockTitle: 'Удобные бесплатные сервисы для наших клиентов',
        services: [
            {
                name: 'Узнай, когда заканчивается твой полис ОСАГО',
                link: '/services/check-osago',
            },
            {
                name: 'Поиск и проверка данных автомобиля по гос. номеру по базе ГИБДД',
                link: '/services/gibdd',
            },
            {
                name: 'Поиск и проверка техосмотра по базе ЕАИСТО',
                link: '/services/dcard',
            },
            {
                name: 'Поиск и проверка полиса ОСАГО по базе РСА',
                link: '/services/',
            },
            // {
            //     name: 'Бесплатное восстановление и поиск КБМ',
            //     link: '/services/kbm',
            // },
            {
                name: 'Бесплатное оформление договоров купли-продажи',
                link: '/services/sales-contract',
            },
        ]
    }),
    mounted: function () {
        if (this.title) {
            this.blockTitle = this.title
        }
    }
}
</script>



// WEBPACK FOOTER //
// resources/js/components/services/ServicesList.vue